import configureStore from "./utilities/configureStore";

export default configureStore({});
